"use strict";
/* eslint-disable no-constant-condition */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccessToken = void 0;
const tslib_1 = require("tslib");
const helpers_1 = require("../helpers");
const webEvents_1 = require("../config/webEvents");
const jwt_decode_1 = require("jwt-decode");
const constants_1 = require("../config/constants");
const phone_app_service_1 = require("@arnoldclark/phone-app-service");
const useAccessToken = (isNativeApp, getAccessTokenSilently) => {
    const { invoke } = (0, phone_app_service_1.usePhoneAppService)();
    const requestTokenFromApp = () => {
        return new Promise(resolve => {
            const listener = (ev) => {
                if (ev.detail.type === "TOKEN_UPDATE_SUCCESS") {
                    window === null || window === void 0 ? void 0 : window.removeEventListener("requestToken", listener);
                    resolve(ev.detail.payload.token);
                }
            };
            window === null || window === void 0 ? void 0 : window.addEventListener("requestToken", listener);
            invoke(webEvents_1.WEB_EVENTS.REQUEST_TOKEN, {});
        });
    };
    const getAppAccessToken = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const timeOutError = Symbol();
        const timeoutInMs = Number(5000);
        const maxRetries = Number(1);
        let attempts = 0;
        while (true) {
            try {
                const token = yield (0, helpers_1.timeout)(requestTokenFromApp(), timeoutInMs, timeOutError);
                return token;
            }
            catch (error) {
                if (error === timeOutError && attempts++ >= maxRetries) {
                    throw new Error("Timeout retrieving access token from app");
                }
                else if (error !== timeOutError) {
                    throw error;
                }
            }
        }
    });
    const requestAndSaveAccessToken = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const token = yield getAppAccessToken();
        if (window) {
            window.initialContext.accessToken = token;
        }
        return token;
    });
    const getEmailAddressFromToken = (token) => {
        const decoded = (0, jwt_decode_1.default)(token);
        return decoded[constants_1.CLAIMS.EMAIL];
    };
    const getAccountIdFromToken = (token) => {
        const decoded = (0, jwt_decode_1.default)(token);
        return decoded[constants_1.CLAIMS.ACCOUNTID];
    };
    const getContextAccessToken = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window.initialContext) === null || _a === void 0 ? void 0 : _a.accessToken) {
            return window.initialContext.accessToken;
        }
        else {
            return yield requestAndSaveAccessToken();
        }
    });
    return {
        getAuthHeaders: (headers = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            if (typeof headers.Authorization === "undefined") {
                let token;
                if (isNativeApp) {
                    //if in native app - calls custom token retrieval method
                    token = yield requestAndSaveAccessToken();
                }
                else {
                    //if in web app - calls auth0 method
                    token = yield getAccessTokenSilently();
                }
                return Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${token}` });
            }
            return headers;
        }),
        fetchWithAuthRetry: (url, options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            return fetch(url, options).then((response) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                if (response.status === 401) {
                    let token;
                    if (isNativeApp) {
                        //if in native app - calls custom token retrieval method
                        token = yield requestAndSaveAccessToken();
                    }
                    else {
                        //if in web app - calls auth0 method
                        token = yield getAccessTokenSilently();
                    }
                    const newOptions = {
                        headers: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.headers), { Authorization: `Bearer ${token}` })
                    };
                    return fetch(url, newOptions);
                }
                else {
                    return response;
                }
            }));
        }),
        getUpdatedAccessToken: () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            if (isNativeApp) {
                //if in native app - calls custom token retrieval method
                return yield requestAndSaveAccessToken();
            }
            else {
                //if in web app - calls auth0 method
                return yield getAccessTokenSilently();
            }
        }),
        getAccessToken: () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            if (isNativeApp) {
                //if in native app - calls custom token retrieval method
                return yield getContextAccessToken();
            }
            else {
                //if in web app - calls auth0 method
                return yield getAccessTokenSilently();
            }
        }),
        getEmailAddress: () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            var _b, _c, _d, _e;
            if (isNativeApp) {
                return ((_b = window === null || window === void 0 ? void 0 : window.initialContext) === null || _b === void 0 ? void 0 : _b.accessToken)
                    ? getEmailAddressFromToken((_c = window === null || window === void 0 ? void 0 : window.initialContext) === null || _c === void 0 ? void 0 : _c.accessToken)
                    : (_e = (_d = window === null || window === void 0 ? void 0 : window.initialContext) === null || _d === void 0 ? void 0 : _d.user) === null || _e === void 0 ? void 0 : _e.emailAddress;
            }
            else {
                const token = yield getAccessTokenSilently();
                return getEmailAddressFromToken(token);
            }
        }),
        getAccountId: () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            var _f, _g;
            if (isNativeApp) {
                return ((_f = window === null || window === void 0 ? void 0 : window.initialContext) === null || _f === void 0 ? void 0 : _f.accessToken)
                    ? getAccountIdFromToken((_g = window === null || window === void 0 ? void 0 : window.initialContext) === null || _g === void 0 ? void 0 : _g.accessToken)
                    : "";
            }
            else {
                const token = yield getAccessTokenSilently();
                return getAccountIdFromToken(token);
            }
        })
    };
};
exports.useAccessToken = useAccessToken;
//# sourceMappingURL=use-access-token.js.map